import type { ClientVariant, Variant, LeanVariant } from '../types'

export function convertToLean(variants: (ClientVariant | Variant)[]): LeanVariant[] {
  return variants.map(variant => ({
    id: variant.id,
    conditions: variant.conditions,
    isDefault: variant.isDefault,
  }))
}
